/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import "./rewardDetails.scss";
import GroupWrapItem from "./friendsCard";
import Pagination from "./pagination";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import  DefaultHearder  from "@/app/csr-src/assets/icons/default-avatar.svg";
import NoData from "./noData";
import { useState, useEffect } from "react";
import { getTaskProcessDetailApi } from "@/app/csr-src/apis/invitePolitely/invitePolitely.api";
import UKPageLoading from "@/common-components-src/components/UKPageLoading";

export default function RewardDetails({
  isCodeType,
  activityId,
  taskProcess,
  currency,
  onInvitingCheck,
}: any) {
  const [userList, setUserList] = useState([]);
  const [currentSelected, setCurrentSelected] = useState("SUCCESS"); // SUCCESS  PENDING
  const [couponInfo, setCouponInfo] = useState({
    receiveQty: 0,
    awardType: 1,
    coupon: {
      discount: 0,
      quota: 0,
      couponType: 1,
    },
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const pageSize = 20;

  const getData = async () => {
    setIsLoading(true);
    const params = {
      activityId,
      processType: currentSelected === "SUCCESS" ? 2 : 1,
      currentPage,
      pageSize,
    };
    if (activityId) {
      const res: any = await getTaskProcessDetailApi(params);
      if (res?.code == "200") {
        const { data, total } = res?.data || [];
        if (res?.data?.data) {
          setUserList(res.data.data);
        } else {
          setUserList([]);
        }
        setCurrentPage(currentPage);
        setTotal(total);
        setIsLoading(false);
      }
    } else {
      console.log("djh-no-activityid!!!");
    }
    setIsLoading(false);
  };

  const pagesChangeHandler = (val: number) => {
    setCurrentPage(val);
  };
  const tabChange = (state: string) => {
    setUserList([]);
    setIsLoading(true);
    setCurrentPage(1);
    console.log("state======", state);
    switch (state) {
      case "SUCCESS":
        setCurrentSelected("SUCCESS");
        break;
      case "PENDING":
        setCurrentSelected("PENDING");
        break;
      default:
        setCurrentSelected("SUCCESS");
    }
  };

  useEffect(() => {
    let info = {
      receiveQty: 0,
      awardType: 1,
      coupon: {
        discount: 0,
        quota: 0,
        couponType: 1,
      },
    };
    if (
      taskProcess &&
      taskProcess.receiveAwards &&
      taskProcess.receiveAwards[0] &&
      taskProcess.receiveAwards[0].awards &&
      taskProcess.receiveAwards[0].awards[0]
    ) {
      info = taskProcess.receiveAwards[0].awards[0];
    }
    // const info = taskProcess?.receiveAwards[0]?.awards[0];
    setCouponInfo({
      receiveQty: info.receiveQty,
      awardType: info.awardType,
      coupon: info.coupon,
    });
  }, [taskProcess]);

  useEffect(() => {
    getData();
  }, [currentPage]);

  useEffect(() => {
    getData();
  }, [currentSelected]);

  if (userList?.length <= 0) {
    return;
  } else {
    return (
      <div className="rewardDetailWrap">
        {!isCodeType && (
          <div className="titleTabFloor">
            <div className="titleTabBox">
              <div
                className={`title ${currentSelected === "SUCCESS" ? "selected" : ""}`}
                onClick={() => tabChange("SUCCESS")}
              >
                <div>Success ({taskProcess?.success ? taskProcess.success : 0})</div>
                <div className="line"></div>
              </div>
              <div
                className={`title ${currentSelected === "PENDING" ? "selected" : ""}`}
                onClick={() => tabChange("PENDING")}
              >
                <div>Pending ({taskProcess?.pending ? taskProcess.pending : 0})</div>
                <div className="line"></div>
              </div>
            </div>
          </div>
        )}
        {currentSelected === "SUCCESS" && userList?.length > 0 ? (
          <>
            {isCodeType && (
              <Box
                sx={{ textAlign: "center", color: "#1a1a1a", fontSize: "18px", fontWeight: 700 }}
              >
                The coupons you earned:
              </Box>
            )}
            <div className="couponFloor">
              <div
                className={`couponCard ${couponInfo?.coupon.couponType === 1 ? "redTheme" : "greenTheme"}`}
              >
                <span className="font-big fontJD">
                  {currency}
                  {couponInfo?.coupon?.discount ? couponInfo?.coupon?.discount : 0}
                </span>
                {couponInfo?.coupon.couponType === 1 ? (
                  <div>
                    <span className="font-small  mr24">Off</span>
                    <span className="font-small ">Over</span>
                    <span className="font-small fw800 fontJD">
                      &nbsp;{currency}
                      {couponInfo?.coupon?.quota ? couponInfo?.coupon?.quota : 0}
                    </span>
                  </div>
                ) : (
                  <div>
                    <span className="font-small  ml12">Shipping off</span>
                  </div>
                )}
              </div>
              <span className="font-middle20 ml">x</span>
              <span className="font-middle28 fontJD">
                {couponInfo?.receiveQty ? couponInfo?.receiveQty : 0}
              </span>
            </div>
          </>
        ) : null}

        {isLoading && (
          <div className="loadPage">
            <UKPageLoading />
          </div>
        )}
        {!isLoading && (
          <>
            {isCodeType && userList.length > 0 && (
              <Box
                sx={{
                  marginTop: "28px",
                  textAlign: "center",
                  color: "#1a1a1a",
                  fontSize: "18px",
                  fontWeight: 700,
                }}
              >
                The friends you referred:
              </Box>
            )}
            <div className="teammateFloor">
              <div className="groupWrap">
                {currentSelected === "SUCCESS" && !isCodeType && (
                  <div className="groupWrapItem">
                    <DefaultHearder className="headerIcon" />
                    <p className="name">Waiting for inviting</p>
                    <Button variant="outlined" onClick={onInvitingCheck} className="inviteBtn">
                      Keep inviting
                    </Button>
                  </div>
                )}
                {userList.map((v: any, i: number) => {
                  return <GroupWrapItem status={currentSelected} key={i} data={v} />;
                })}
              </div>
              {!userList.length && <NoData msg={"There's nothing more"} />}
            </div>
          </>
        )}
        <div className="pageWrap">
          {total && !isLoading ? (
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(total / 20)}
              handlePageChange={pagesChangeHandler}
            />
          ) : null}
        </div>
      </div>
    );
  }
}
